import React from "react";
import ReactDOM from "react-dom";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const defaultTheme = {
  fontFamily: "Helvetica Neue",
  fontSize: "16px",
  borderRadius: "6px",
  borderColor: "#4099ff"
};

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: inherit;
  }
  body {
    color: ${props => (props.whiteColor ? "white" : "black")};
    font-family: ${props => props.theme.fontFamily};
  }
  input,
  select,
  button {
    height: 44px;
    border-radius: ${props => props.theme.borderRadius};
    border-color: ${props => props.theme.borderColor};
  }
`;

function AppContainer() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <React.Fragment>
        <App />
        <GlobalStyle whiteColor={false} />
      </React.Fragment>
    </ThemeProvider>
  );
}

ReactDOM.render(<AppContainer />, document.getElementById("root"));

serviceWorker.unregister();
